var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"pageContainer",staticClass:"vms__page-container",class:{ 'vms__page-container--loading': !_vm.loaded },style:({
    width: _vm.getPageWidth(),
    height: _vm.getPageHeight()
  }),attrs:{"id":"PageScrollbar"}},[_vm._t("default"),_c('transition',{attrs:{"name":"main-fade","mode":"out-in"}},[(!_vm.loaded)?_c('UIPreloader'):_vm._e()],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }